import React, { useEffect, useState } from 'react';
import { Button, Header, Image, Placeholder, Stat } from 'react-frontier';
import { useTitle, useUser } from '../Hooks';
import { Link, useParams } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { UserInfoStats } from '../Classes';
import { addCommas } from '@tempu/components/Util';
import API from '../API';

interface UserProfileProps{
	userId?: number,
	self?: boolean,
}

var UserProfile = (props: UserProfileProps)=>{
	const IS_SELF = props.self || (props.userId || parseInt(params.id))==user.user_id;
	var params = useParams<{ id: string }>();
	var { setTitle } = useTitle();
	var { user, logout } = useUser();
	var [userData, setUserData] = useState<UserInfoStats>(null);
	var [loadError, setLoadError] = useState<string>(null);

	useEffect(()=>{
		if(props.self){
			setTitle('Perfil');
		}

		API.getUserInfoStats().then(res=>{
			if(res.error) return setLoadError(res.message);
			setUserData(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error inesperado cargando la información del usuario (LCL-USRIFST-1)');
		});
	}, []);
	
	return <div className="tp user-profile-screen">
		<div className="container user">
			<div className="avatar">
				<Image src={user.image} fallbackComponent={(
					<i className='user icon' />
				)} />
			</div>
			<div className="info">
				<div className="id">Usuario #{user.user_id}</div>
				<div className="name">{user.first_name} {user.last_name}</div>
				{userData ? (
					<div className="place">{userData.city}, {userData.state}</div>
				) : (
					<Placeholder style={{ backgroundColor: 'rgba(0,0,0,0.08)' }} />
				)}
				{/* {IS_SELF ? (
					<Button size='tiny' color='black' text='Editar cuenta' iconName='pencil' style={{ marginTop: 5, width: 150, display: 'block' }} as={Link} to={'/settings'} />
				) : null} */}
			</div>
		</div>
		<div className="stats">
			<Stat value={(
				userData ? addCommas(userData.postings, false) : <Placeholder height={38} />	
			)} label={'Trabajos'} />
			<Stat value={(
				userData ? addCommas(userData.businesses, false) : <Placeholder height={38} />	
			)} label={'Empresas'} />
		</div>
		<div className="code">
			<div className="qr">
				<QRCodeSVG value={`ebentu://user/${user.user_id}`} size={250} />
			</div>
			<Header text='Código de usuario' />
			<div className="text">Podrás usar este código para registrar tu asistencia en tus trabajos autorizados.</div>
		</div>
	</div>
}

export default UserProfile;